function openPopUp(){
  var popup = document.getElementById("BISpopup");
  popup.classList.add("show");
  window.addEventListener("click", function (event) {
            if (event.target == popup) {
                popup.classList.remove("show");
            }
  });
  if (document.getElementById("BISSubmit").classList.contains('hide_input')) {
    document.getElementById("BIS_form_success_notice").classList.remove("show")
      document.getElementById("BISSubmit").classList.remove("hide_input")
  }
}

function closePopUp(){
  document.getElementById("BISpopup").classList.remove("show");
}